export default __webpack_public_path__ + "static/media/red-x-icon.5cc943d2.png";